import { useNavigate, useLocation } from 'react-router-dom';
import { triggerDeepLink } from '@core/utils/deep-link';
import { ROUTES } from './route-constants';

export function useBackButton() {
  const navigate = useNavigate();
  const location = useLocation();

  // We're at root if the path matches the LIST route
  const isAtRoot = location.pathname === ROUTES.LIST;

  const goBack = () => {
    if (!isAtRoot) {
      navigate(-1);
    } else {
      // At root, close WebView
      triggerDeepLink({ action: 'closed' });
    }
  };

  return { goBack, canGoBack: !isAtRoot };
}
